import order from './order'

export default {
  platform: order,
}
